var _rect, _circle, _circle2, _line, _line2, _line3, _circle3, _circle4, _circle5, _rect2, _path, _circle6, _circle7, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcNosearchresult(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 83,
    viewBox: "0 0 100 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 51.209,
    y: 47.9166,
    width: 30.2983,
    height: 8.89857,
    rx: 2.66957,
    transform: "rotate(45 51.209 47.9166)",
    fill: "#BDBDBD"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.916,
    cy: 35.916,
    r: 23.916,
    fill: "white",
    stroke: "#BDBDBD",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.916,
    cy: 35.9159,
    r: 19.7805,
    fill: "white",
    stroke: "#BDBDBD"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 19.6782,
    y1: 34.0262,
    x2: 28.3565,
    y2: 34.0262,
    stroke: "#BDBDBD",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 37.4753,
    y1: 34.0262,
    x2: 46.1536,
    y2: 34.0262,
    stroke: "#BDBDBD",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 31.2466,
    y1: 43.8146,
    x2: 34.5857,
    y2: 43.8146,
    stroke: "#BDBDBD",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 68.5104,
    cy: 53.7132,
    r: 2.66957,
    fill: "#BDBDBD"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 77.4088,
    cy: 53.7132,
    r: 2.66957,
    fill: "#BDBDBD"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 86.3075,
    cy: 53.7132,
    r: 2.66957,
    fill: "#BDBDBD"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.614541,
    y: 0.349771,
    width: 5.229,
    height: 1.66957,
    rx: 0.834786,
    transform: "matrix(0.264769 0.964312 0.964312 -0.264769 89.2 16.0267)",
    stroke: "#BDBDBD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.9917 15.5544C88.9817 16.3592 91.2257 17.2503 92.2822 14.3764",
    stroke: "#BDBDBD",
    strokeLinecap: "round"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    r: 1.72464,
    transform: "matrix(0.264769 0.964312 0.964312 -0.264769 88.6229 19.5337)",
    stroke: "#BDBDBD"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    r: 1.72464,
    transform: "matrix(0.264769 0.964312 0.964312 -0.264769 93.7716 18.12)",
    stroke: "#BDBDBD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5729 45.4447C64.5591 41.7771 64.3804 34.4871 71.7765 34.6677C81.0217 34.8936 82.7728 28.1797 78.4112 26.6675C74.0495 25.1552 71.9778 33.8564 80.0754 38.3621C88.173 42.8679 93.4018 31.1602 92.4139 23.3364",
    stroke: "#BDBDBD",
    strokeLinecap: "round",
    strokeDasharray: "1.78 1.78"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNosearchresult);
export default __webpack_public_path__ + "static/media/ic_nosearchresult.862a0818d02a32866fb05628b3d5f231.svg";
export { ForwardRef as ReactComponent };